
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';

export default {
    name: 'Finishing2',
    components: { Swiper, SwiperSlide },

    props: {
        title: {
            type: String,
            default: '',
        },
        message: {
            type: String,
            default: '',
        },
        images: {
            type: Array,
            default: () => [],
        },
    },

    data() {
        const vnode = (Math.random() + 1).toString(36).substring(7);
        return {
            swiperOptions: {
                spaceBetween: 30,
                slidesPerView: 1,
                slidesPerGroup: 1,
                loop: true,

                navigation: {
                    prevEl: `#finishing-button-navigation-${vnode}-prev`,
                    nextEl: `#finishing-button-navigation-${vnode}-next`,
                },
            },

            activeSlide: 0,

            isMobile: false,

            vnode,
        };
    },

    mounted() {
        if (window.innerWidth < 1024) {
            this.isMobile = true;
        }
    },

    methods: {
        openPopUpImages() {
            const activeIndex = this.$refs.refSwiper?.$swiper?.realIndex || 0;
            this.$store.commit('pop-up-images/setImages', {
                images: (this.images || []).map((t) => t.imageId),
                parametrs: {
                    activeIndex,
                },
            });
        },

        slideChange() {
            this.activeSlide = this.$refs.refSwiper?.$swiper?.realIndex || 0;
        },
    },
};
